module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_seminar-4495aea48e3e65892b1b9448eb51a95c.svg";